import NSCellInput from 'bricks/NSCellInput/NSCellInput';
import { numeralFormatter } from 'ns_libs/formatter';
import { IResidentialLotMix } from 'views/ProFormaTable/types';

const TD_CLASS = 'NSTable__tbody__tr__td align-middle px-3 py-2';

export interface ILotTakedownRowProps {
    row: IResidentialLotMix;
    onUpdate: (lotMixId: number, dataKey: 'initialTake' | 'recurringNum', value: number | null) => void;
}

const LotTakedownRow = ({ row, onUpdate }: ILotTakedownRowProps) => (
    <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-1">
        <td className={TD_CLASS}>
            {row.lotName ?? ''}
        </td>
        <td className={`${TD_CLASS} text-right`}>
            {numeralFormatter(row.lotWidth, '0,0')}
        </td>
        <td className={`${TD_CLASS} text-right`}>
            {numeralFormatter(row.lotCount, '0,0')}
        </td>
        <td className={`${TD_CLASS} text-right`}>
            <NSCellInput
                value={row.initialTake ?? ''}
                handleUpdateValue={value => onUpdate(row.id, 'initialTake', value === '' ? null : Number(value))}
                type="number"
                placeholder="0"
                isRightAligned
            />
        </td>
        <td className={`${TD_CLASS} text-right`}>
            <NSCellInput
                value={row.recurringNum ?? ''}
                handleUpdateValue={value => onUpdate(row.id, 'recurringNum', value === '' ? null : Number(value))}
                type="number"
                placeholder="0"
                isRightAligned
                disableOptimisticUpdate
            />
        </td>
    </tr>
);

export default LotTakedownRow;
